import { ActionTypes } from './constants'

function handleBlogFilterChipSelectionStateChange(payload, dispatch) {
  dispatch({
    type: ActionTypes.selectBlogFilter,
    payload,
  })
}
function handleFiltersAndKeysUpdateOnStateChange(
  payload /*{documents, totalItemsSize}*/,
  dispatch
) {
  dispatch({
    type: ActionTypes.updateFiltersItemsAndKeysUpdate,
    payload,
  })
}
function handleClearAllFiltersStateChange(dispatch) {
  dispatch({
    type: ActionTypes.clearBlogFilters,
  })
}
function handleUpdateParametersOnStateChange(payload, dispatch) {
  dispatch({
    type: ActionTypes.updateParameters,
    payload,
  })
}
function handleItemsVisibleOnStateChange(dispatch) {
  dispatch({
    type: ActionTypes.updateItemsVisible,
  })
}
function handleUpdateSelectedSearchOnStateChange(payload, dispatch) {
  dispatch({
    type: ActionTypes.searchForPosts,
    payload,
  })
}

export {
  handleBlogFilterChipSelectionStateChange,
  handleClearAllFiltersStateChange,
  handleFiltersAndKeysUpdateOnStateChange,
  handleUpdateParametersOnStateChange,
  handleItemsVisibleOnStateChange,
  handleUpdateSelectedSearchOnStateChange,
}
